module.exports = __webpack_public_path__ + "img/Paraguay.813a13fa.svg";